var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-page',{attrs:{"page-title":"Leases","page-icon":"mdi-file-document-outline","collection-name":"lease","items-per-page":20,"add-dialog-title":"Add Lease","is-filter":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }